import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=065f21da&"
import script from "./InfoForm.vue?vue&type=script&lang=js&"
export * from "./InfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports